// Drop-in replacement for vuex-class's namespaced State/Getter/Action/Mutation
// decorators, built on vue-facing-decorator's custom-decorator API.
// All call sites use the two-arg namespaced form and stay byte-identical
// except for the import path.
import { createDecorator } from 'vue-facing-decorator'

interface NamespaceOptions {
  namespace: string
}

// Adds a computed (getterFn) or method (methodFn) to the built component options.
function computedDecorator(getterFn: (vm: any) => any) {
  return createDecorator((options, key) => {
    options.computed = options.computed || {}
    options.computed[key] = function (this: any) {
      return getterFn(this)
    }
  })
}

function methodDecorator(methodFn: (vm: any, args: any[]) => any) {
  return createDecorator((options, key) => {
    options.methods = options.methods || {}
    options.methods[key] = function (this: any, ...args: any[]) {
      return methodFn(this, args)
    }
  })
}

export function State(stateKey: string, opts: NamespaceOptions) {
  return computedDecorator((vm) => vm.$store.state[opts.namespace][stateKey])
}

export function Getter(getterKey: string, opts: NamespaceOptions) {
  return computedDecorator((vm) => vm.$store.getters[`${opts.namespace}/${getterKey}`])
}

export function Action(actionKey: string, opts: NamespaceOptions) {
  return methodDecorator((vm, args) => vm.$store.dispatch(`${opts.namespace}/${actionKey}`, ...args))
}

export function Mutation(mutationKey: string, opts: NamespaceOptions) {
  return methodDecorator((vm, args) => vm.$store.commit(`${opts.namespace}/${mutationKey}`, ...args))
}
